/* ---------------------------------------------------------------------------
   DreamPrices - smarre rattningar i kopflodet (2026-09-11).

   PRICERUNNER-MARKET
   Produktsidan renderar alltid behallaren .pricerunner-badge med en bild fran
   api.pricerunner.com. Har PriceRunner inget "billigast"-marke for artikelns
   SKU svarar API:et med en genomskinlig 1x1-pixel - alltsa inget fel, bara en
   osynlig bild. Behallaren stod dock kvar med 48px marginal over och 30px
   under, vilket lamnade ett tomt hal pa ca 110px mellan priset och
   varumarkesraden. Det gick inte att losa i CSS: en 1x1-pixel gar inte att
   traffa med en selektor.

   Darfor mats bildens verkliga bredd. Ett riktigt marke begars i 180px bredd,
   sa allt under GRANS ar en tompixel (eller en bild som inte gick att hamta).
   Da doljs behallaren. Finns markret ror vi ingenting - och dyker det upp
   senare for en artikel borjar det visas av sig sjalvt.

   Laddas fran snippets/dp-brand-buttons.liquid. Ta bort filen + den raden
   for att rulla tillbaka.
   --------------------------------------------------------------------------- */
(function () {
  "use strict";
  if (window.__dpOrderflode) return;
  window.__dpOrderflode = true;

  var GRANS = 20; /* px - riktiga marken ar ~180px breda, tompixeln 1px */

  function dolj(box) {
    if (box.getAttribute("data-dp-dold") === "1") return;
    box.setAttribute("data-dp-dold", "1");
    box.style.display = "none";
  }

  function granska(box) {
    if (box.getAttribute("data-dp-granskad") === "1") return;

    var img = box.querySelector("img");
    if (!img) {
      box.setAttribute("data-dp-granskad", "1");
      dolj(box);
      return;
    }

    function avgor() {
      box.setAttribute("data-dp-granskad", "1");
      if (img.naturalWidth < GRANS) dolj(box);
    }

    /* complete blir sant aven nar hamtningen misslyckades - da ar
       naturalWidth 0 och villkoret ovan tacker bada fallen. */
    if (img.complete) {
      avgor();
    } else {
      img.addEventListener("load", avgor, { once: true });
      img.addEventListener("error", function () {
        box.setAttribute("data-dp-granskad", "1");
        dolj(box);
      }, { once: true });
    }
  }

  function kor() {
    var boxar = document.querySelectorAll(".pricerunner-badge");
    for (var i = 0; i < boxar.length; i++) granska(boxar[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", kor);
  } else {
    kor();
  }

  /* Temat ritar om delar av produktsidan vid variantbyte. */
  document.addEventListener("shopify:section:load", kor);
  window.addEventListener("load", kor);
})();
